export enum UserFilter {
  Registered = 'REGISTERED',
  OnWaitingList = 'WAITING_LIST',
  PendingApproval = 'PENDING_APPROVAL',
  Member = 'ACTIVE'
}
